import React, { useMemo } from "react";
import { SpaceCard, SpaceCardSkeleton } from "reusableComponents";
import NoSpaceFound from "../NoSpaceFound";
import ErrorMessage from "../ErrorMessage";
import styles from "./styles.module.scss";
import SpaceCardStyledSkeleton from "reusableComponents/skeletons/SpaceCardStyledSkeleton";
import SpaceCardStyled from "reusableComponents/SpaceCardStyled";

const SpacesList = ({
  loading,
  spaces,
  pagination = {per_page: 100},
  error,
  onHoverSpace = () => {},
  onLeaveSpace = () => {},
  resetPrevFilters,
  showResetButton,
}) => {
  const spacesRender = useMemo(() => {
    if (loading) {
      return Array.from({ length: pagination.per_page }).map((_, idx) => (
        <SpaceCardStyledSkeleton key={idx} />
      ));
    }

    if (error) {
      return <></>;
      // <ErrorMessage error={error} />;
    }

    if (spaces.length > 0) {
      return spaces.map((space) => (
        <SpaceCardStyled
          place={space}
          key={`${space.id}-${Math.random()}`}
          onHover={() => onHoverSpace(space)}
          onLeave={onLeaveSpace}
        />
      ));
    }

    return <NoSpaceFound resetPrevFilters={resetPrevFilters} showResetButton={showResetButton}/>;
  }, [loading, spaces, error, pagination.per_page]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.spacesListWrapper}>{spacesRender}</div>
    </div>
  );
};

export default SpacesList;
